import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "icon"
}
const _hoisted_2 = { class: "toolTip" }
const _hoisted_3 = {
  key: 1,
  class: "o-btn"
}
const _hoisted_4 = { key: 1 }

import { ref, computed } from "vue";
import { useStore } from "vuex";
import { AddPurchasableToCart } from "../../api/cart/addPurchasableToCart";
import Loader from "./Loader.vue";
import CartIcon from "@web/assets/icon/cart.svg";
import CartAddPlus from "@web/assets/icon/cartAddPlus.svg";

type Props = {
	id: number;
	stock: any;
	variants?: Array<any>;
	inline?: boolean;
	version?: "default" | "routine";
};

export default /*#__PURE__*/_defineComponent({
  __name: 'CartAddPurchasable',
  props: {
    id: {},
    stock: {},
    variants: {},
    inline: { type: Boolean },
    version: {}
  },
  setup(__props: any) {

const store = useStore();
const translations = store.state.translations.siteTranslations;

const props = __props;

const hasVariants = props.variants?.length && props.stock?.status == "VARIANT";
const isInactive = ["VOUCHER", "OUTOFSTOCK"].includes(props.stock?.status);
const isLoading = ref(false);

const cartIcon = computed(() => {
    return props.version === "routine" ? CartAddPlus : CartIcon;
});

const loaderColor = computed(() => {
	return props.version === "routine" ? "white" : "blue";
});

const text = computed(() => {
	if (hasVariants) {
		return translations["Choose variant"];
	}

	switch (props.stock.status) {
		case "STOCK":
		case "VOUCHER":
			return translations["Add to cart"];
		case "BACKORDER":
			return translations["Backorder"];
		case "PREORDER":
			return translations["Preorder"];
		case "OUTOFSTOCK":
		default:
			return translations["Notify"];
	}
});

async function request(e: MouseEvent) {
	// Let the parent component handle the click if the element is inactive
	if (isInactive) {
		return;
	}

	// prevent default here, as we want the propergation to happen if element is inactive state
	e.preventDefault();


	if (hasVariants) {
		store.dispatch("status/openVariantSelector", props.variants);
		return;
	}

	isLoading.value = true;
	const response = await AddPurchasableToCart({
		purchasableId: props.id,
		stock: props.stock.status,
		qty: "1",
	});

	if (response.data.cart) {
		store.dispatch("commerce/cart", response.data.cart);
	}

	isLoading.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-cartAddPurchasable", {
			'c-cartAddPurchasable--inactive': _unref(isInactive),
			'c-cartAddPurchasable--inline': props.inline,
			[`c-cartAddPurchasable--${props.version}`]: props.version
		}]),
    onClick: _cache[0] || (_cache[0] = e => request(e))
  }, [
    (props.inline)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (isLoading.value)
            ? (_openBlock(), _createBlock(Loader, {
                key: 0,
                class: _normalizeClass(["o-loader--column o-loader--tiny", ['o-loader--' + loaderColor.value]])
              }, null, 8, ["class"]))
            : (_openBlock(), _createBlock(_resolveDynamicComponent(cartIcon.value), { key: 1 })),
          _createElementVNode("div", _hoisted_2, _toDisplayString(text.value), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_TransitionGroup, { name: "fade" }, {
            default: _withCtx(() => [
              (isLoading.value)
                ? (_openBlock(), _createBlock(Loader, { key: 0 }))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(text.value), 1))
            ]),
            _: 1
          })
        ]))
  ], 2))
}
}

})